import { HOME, PRIVACY_POLICY } from "../../constants/routes";
import { NavItem } from "./UiShell.types";

export const navItems: NavItem[] = [
  {
    name: "Dashboard",
    url: HOME,
  },
  {
    name: "Privacy Policy",
    url: PRIVACY_POLICY,
  },
];
